export default __webpack_public_path__ + "images/ML.6fce16a.png";